import $ from 'jquery'

var actionGearDark = function($element, options) {
  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $actionGear,
      $actionGearArr,
      disabled = false;

  /* PRIVATE METHODS */

  // constructor
  function init() {
    $actionGear = $('.actions-wrapper', $mainContainer);

    if (options && options['confirmations_enabled']) { procConfirmationIfPresent(); }

    bindDomEvents();
  }

  function bindDomEvents() {

    $('.actions', $mainContainer).on('keydown', function(e) {
      if (!disabled && e.keyCode == $.ui.keyCode.TAB && e.shiftKey) {
        $actionGear.removeClass('active');
        $actionGear.parents('.content-item').removeClass('zindex');
      }
    });

    $actionGear.on('focusin', function() {
      if (!disabled) {
        $actionGear.addClass('active');
        $actionGear.parents('.content-item').addClass('zindex');
      }
    });

    $('.actions-dropdwn li:last a, .actions-dropdwn li:last button', $mainContainer).on('keydown', function(e) {
      if (e.keyCode == $.ui.keyCode.TAB && !e.shiftKey) {
        $actionGear.removeClass('active');
        $actionGear.parents('.content-item').removeClass('zindex');
      }
    });

    $actionGear.on('mouseenter', function() {
      if (!disabled) {
        $actionGear.addClass('active');
        $actionGear.parents('.content-item').addClass('zindex');
      }
    }).on('mouseleave', function() {
      if (!disabled) {
        $actionGear.removeClass('active');
        $actionGear.parents('.content-item').removeClass('zindex');
      }
    });

    $actionGear.on('touchstart', function(e) {
      var $target = $(e.target);

      $actionGearArr = $('.actions-wrapper', $(document));

      if ($target.hasClass('actions')) {
        e.preventDefault();

        if (!disabled) {
          $actionGearArr.removeClass('active');
          $actionGear.addClass('active');
          $actionGear.parents('.content-item').toggleClass('zindex');
        }
      }
    });

    $('body').on('touchstart', function(e) {
      var $target = $(e.target);

      if ( $target.parents('.actions-wrapper').length == 0) {
        $actionGear.removeClass('active');
        $actionGear.parents('.content-item').removeClass('zindex');
      }
    });


  }

  function procConfirmationIfPresent() {
    $('.actions-dropdwn').each(function(i, el){
      var $gear_el = $(el);
      $('li', $gear_el).each(function(i, li_el) {
        var $li_el = $(li_el);
        var $form = $('form', $li_el);
        $form.off('submit');
        $form.on('submit', function(event) {
          event.preventDefault();
          var $this = $(this);
          var $parent_li = $form.parent();
          var confirmation_text = $parent_li.data('confirmationText');
          if (confirmation_text) {
            SOPHIA.confirm(confirmation_text, function() { $form.unbind('submit'); $form.trigger('submit'); }, $('button', $this), {relaunchConfirm: true});
          } else {
            $form.unbind('submit').trigger('submit');
            //prevent double clicking
            $form.on('submit', function(e) { e.preventDefault() });
          }
        });
      });
    });
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
    // public methods go here
    enable: function() {
      disabled = false;
      $actionGear.removeClass('disabled');
    },

    disable: function() {
      disabled = true;
      $actionGear.addClass('disabled').removeClass('active');
      $actionGear.parents('.content-item').removeClass('zindex');
    }
  };
};

// jQuery plugin method
$.fn.actionGearDark = function(options) {
  return this.each(function() {
    var $this = $(this);

    // Store plugin object in this element's data if it doesn't already exist
    if (!$this.data('actionGearDark')) {
      $this.data('actionGearDark', actionGearDark($this, options));
    }
  });
};
